import cx from 'classnames';
import { BZ2_FILTER_PRICE_MAX, BZ2_FILTER_PRICE_MIN } from 'mk/autogenerated/translations/PriceSelect.251da47d02f4d6af2cb2065910792271'
import { PriceType } from 'mk2/apps/bazaar/components/PriceFacetDropdown';
import { InputField } from 'mk2/components/forms/InputField';
import { mkReduxForm, MKReduxFormInjectedProps } from 'mk2/decorators/mkReduxForm';
import { normalizeToFloat } from 'mk2/helpers/form';
import React from 'react';
import { FormErrors } from 'redux-form';
import styles from './PriceSelect.mscss';

export const PRICE_SELECT_FORM_NAME = 'PRICE_SELECT_FORM_NAME';

export interface FormValues {
    min: number;
    max: number;
}

interface OwnProps {
    className?: string;
    initialValues: FormValues;
    onChange(priceType: PriceType, value: number);
}

const onSave = () => null; // Noop

type Props = OwnProps;

interface State {
    min: number;
    max: number;
}

class PriceSelect extends React.Component<Props & MKReduxFormInjectedProps<FormValues, Props>, State> {
    public static validate(values: FormValues, props: OwnProps) {
        const errors: FormErrors<FormValues> = {};
        return errors;
    }

    public state: State = {
        min: this.props.initialValues.min || 0,
        max: this.props.initialValues.max,
    };

    public render() {
        const { className } = this.props;
        return (
            <div className={cx(styles.PriceSelect, className)}>
                <InputField
                    name="min"
                    type="number"
                    label={BZ2_FILTER_PRICE_MIN}
                    normalize={normalizeToFloat}
                    autoFocus
                    onChange={this.onChange}
                    min="0"
                    max={this.state.max?.toString()}
                />
                <InputField
                    name="max"
                    type="number"
                    label={BZ2_FILTER_PRICE_MAX}
                    normalize={normalizeToFloat}
                    onChange={this.onChange}
                    min={this.state.min?.toString() || '0'}
                />
            </div>
        );
    }

    private onChange = (event, value, prevValue, name: PriceType) => {
        this.props.onChange(name, value);
        if (name === 'min') {
            this.setState({ min: value });
        } else if (name === 'max') {
            this.setState({ max: value });
        }
    };
}

export default mkReduxForm<FormValues, OwnProps>({
    formName: PRICE_SELECT_FORM_NAME,
    onSave,
    onValidate: PriceSelect.validate,
    disableDirtyCheck: true,
})(PriceSelect);
